import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "mt-5 d-md-flex justify-content-end px-12 align-items-center" }
const _hoisted_3 = { class: "me-md-5 mt-md-0 ms-0 ms-md-3 mt-5" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "w-100 btn btn-sm background_btn_1_opct text-white w-32" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }),
  /*#__PURE__*/_createTextVNode(" Novo pacote ")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "las la-edit fs-5 me-2" }, null, -1)

import TreeCardapio from "@/views/cardapio/tree/TreeCardapio.vue";
import Edit from "@/views/cardapio/tree/components/Edit.vue";
import { onMounted, reactive, ref } from "vue";
import router from "@/router";
import { usePackage } from "@/pinia/cardapio/package/usePackage";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { RouteParamsRaw } from "vue-router";
import MenuDropdown from "@/views/cardapio/components/menuDropdown/MenuDropdown.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardapioEdit',
  setup(__props) {

const treeCardapio = ref(null);
const edit = ref(null);
const storePackage = usePackage();

const handleAddItemPackage = async () => {
  const packageFormate = storePackage.getPackage.reduce((acc, { codPackage, name }) => {
    if (codPackage) {
      acc[codPackage] = name;
    }
    return acc;
  }, {});

  const selectedPackage = await swalSelect(
    packageFormate,
    "Escolha o Pacote que deseja editar."
  );
};

const menuHeaders = reactive([
  {
    sectionTitle: "Fábrica",
    sub: [
      {
        id: 1,
        heading: "Listar Itens Fábrica",
        route: goTo("listarItens"),
        svgIcon: "./media/icons/duotune/files/fil024.svg",
        exportKey: null,
        classIcon: "m-nav__link-icon la la-list-alt",
        loading: false,
      },
      {
        id: 2,
        heading: "Exportar Peças",
        route: null,
        svgIcon: "./media/icons/duotune/files/fil024.svg",
        exportKey: "itens",
        classIcon: "m-nav__link-icon la la-download",
        loading: false,
      },
      {
        id: 3,
        heading: "Importar Peças",
        route: goTo("cardapio-importar", { type: "itens" }),
        svgIcon: "./media/icons/duotune/files/fil024.svg",
        exportKey: null,
        classIcon: "m-nav__link-icon la la-file-excel-o",
        loading: false,
      },
      {
        id: 4,
        heading: "Exportar Vínculos/MO",
        route: null,
        svgIcon: "./media/icons/duotune/files/fil024.svg",
        exportKey: "mo",
        classIcon: "m-nav__link-icon la la-download",
        loading: false,
      },
      {
        id: 5,
        heading: "Importar Vínculos/MO",
        route: goTo("cardapio-importar", { type: "mo" }),
        svgIcon: "./media/icons/duotune/files/fil024.svg",
        exportKey: null,
        classIcon: "m-nav__link-icon la la-file-excel-o",
        loading: false,
      },
    ],
  },
  {
    sectionTitle: "Agregados",
    sub: [
      {
        id: 1,
        heading: "Listar Itens Agregados",
        route: goTo("listarItensAgregados"),
        svgIcon: "./media/icons/duotune/files/fil024.svg",
        exportKey: null,
        classIcon: "m-nav__link-icon la la-list-alt",
        loading: false,
      },
      {
        id: 2,
        heading: "Listar Pacotes",
        route: goTo("listarPacote"),
        svgIcon: "./media/icons/duotune/files/fil024.svg",
        exportKey: null,
        classIcon: "m-nav__link-icon la la-list-alt",
        loading: false,
      },
    ],
  },
  {
    sectionTitle: "Outras Opções",
    sub: [
      {
        id: 1,
        heading: "Copiar Cardápio Completo",
        route: goTo("cardapioCopiar", { tipoCopia: "cardapio" }),
        svgIcon: "./media/icons/duotune/files/fil024.svg",
        exportKey: null,
        classIcon: "m-nav__link-icon la la-copy",
        loading: false,
      },
      {
        id: 2,
        heading: "Copiar Peça",
        route: goTo("cardapioCopiar", { tipoCopia: "peca" }),
        svgIcon: "./media/icons/duotune/files/fil024.svg",
        exportKey: null,
        classIcon: "m-nav__link-icon la la-copy",
        loading: false,
      },
    ],
  },
]);

const swalSelect = async (object: object, title: string): Promise<void> => {
  const { value: selectedPackage } = await Swal.fire({
    title: title,
    input: "select",
    inputOptions: object,
    inputPlaceholder: "Selecione Um Pacote",
    showCancelButton: true,
    inputValidator: (value) => {
      return new Promise((resolve: any) => {
        if (value) {
          resolve();
          router.push({
            name: "add-package",
            params: {
              codPacote: value,
            },
          });
        } else {
          resolve("Selecione um pacote)");
        }
      });
    },
  });
};

function goTo(route: string | null, params: RouteParamsRaw = {}) {
  if (route) {
    return router.resolve({ name: route, params }).href;
  }

  return "";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(MenuDropdown, {
          id: "cardapio-edit",
          menu: menuHeaders
        }, null, 8, ["menu"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            href: goTo('add-package')
          }, _hoisted_6, 8, _hoisted_4)
        ]),
        _createElementVNode("div", { class: "mt-md-0 mt-3" }, [
          _createElementVNode("span", {
            onClick: handleAddItemPackage,
            class: "w-100 btn btn-sm background_btn_1_opct text-white w-32"
          }, [
            _hoisted_7,
            _createTextVNode(" Editar Pacote ")
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "col-md-5 col-12",
        ref_key: "treeCardapio",
        ref: treeCardapio
      }, [
        _createVNode(TreeCardapio)
      ], 512),
      _createElementVNode("div", {
        class: "col-md-7 col-12",
        ref_key: "edit",
        ref: edit
      }, [
        _createVNode(Edit)
      ], 512)
    ])
  ]))
}
}

})